// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Anchor: 'anchor',
	ApsEditAnchor: 'aps-edit-anchor',
	ApsEditAnchor1: 'aps-edit-anchor-1',
	ApsEditAnchor2: 'aps-edit-anchor-2',
	ApsEditAnchor3: 'aps-edit-anchor-3',
	ApsEditAnchor4: 'aps-edit-anchor-4',
	MissingInfoAnchor: 'missing-info-anchor',
	OverviewCreateSection: 'overview-create-section',
	QuickActionCreateSection: 'quick-action-create-section',
	QuickContactsCreateSection: 'quick-contacts-create-section',
	InfoCardTitleCreateSection: 'info-card-title-create-section',
	Link: 'link',
	Link1: 'link-1',
	Link2: 'link-2',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
